import styles from './SkeletonChart.module.css';

export function SkeletonChart() {
  return (
    <div className={styles.overlay} role="progressbar" aria-label="Loading chart data">
      <div className={styles.container}></div>
    </div>
  );
}
